import React from 'react';
import { useParams } from 'react-router-dom';

import ControlSystemReportContainer, {
  containerConfiguration,
} from '@totem/components/controlSystemReport/ControlSystemReportContainer';
import BuildingDetailPageSubTitle from '@totem/components/portfolio/buildings/details/BuildingDetailPageSubTitle';
import BuildingDetailPageTitle from '@totem/components/portfolio/buildings/details/BuildingDetailPageTitle';
import BuildingContainer from '@totem/components/portfolio/buildings/details/container/BuildingContainer';
import BuildingTabs from '@totem/components/portfolio/buildings/details/container/BuildingTabs';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

import ContentLayout from '../../../ui_components/page/ContentLayout';

import Sidebar from './sidebar/Sidebar';

import './buildingDetail.css';

const BuildingDetail = () => {
  const { id } = useParams();

  return (
    <BuildingContainer id={id} onDataRefreshRequested={() => {}}>
      <ContentLayout
        pageTitle={<BuildingDetailPageTitle />}
        pageSubtitle={<BuildingDetailPageSubTitle />}
        contentStyle={{ padding: 0 }}
      >
        <div styleName="content">
          <div styleName="content-container">
            <Sidebar />
            <div styleName="main-pane">
              <InputContainer
                filterConfig={containerConfiguration}
                defaultSort={{ field: 'name', direction: 'ascend' }}
                staticFilters={[{ field: 'buildingId', values: [id] }]}
                componentKey={'dashboard.building.controlSystemReport'}
              >
                <ControlSystemReportContainer>
                  <BuildingTabs />
                </ControlSystemReportContainer>
              </InputContainer>
            </div>
          </div>
        </div>
      </ContentLayout>
    </BuildingContainer>
  );
};

export default BuildingDetail;
